export default {
      id: "language-usage",
      viewBox: "0 0 22 12",
      url: "/assets/" + "icons.svg#language",
      toString: function () {
        return this.url;
      }
    }